// src/pages/MyProfile.js
import React from 'react';
/* Removed duplicate NavBar import (already rendered by frame) */
import UserSidebar from '../components/UserSidebar';
import MyRankings from './MyRankings'; // ⬅️ add

/**
 * Mobile-only "My Profile" screen.
 * Reuses the existing UserSidebar UI but renders it in the main content area.
 * On desktop, this route is effectively hidden because the nav item is hidden.
 */
const MyProfile = () => {
  // Mobile check (computed per render; no extra hooks)
  const isMobile = (typeof window !== 'undefined'
    && window.matchMedia
    && window.matchMedia('(max-width: 768px)').matches);

  return (
    <div className="profile-page">
      {/* MOBILE-ONLY OUTLINE WRAPPER */}
      {/* The outline is now applied inside UserSidebar (on .sidebar-inner),
          so this wrapper should NOT add another border. */}
      <div style={undefined}>
        {/* Mobile sees the nav stacked above; desktop keeps existing layout */}
        <UserSidebar />
      </div>
      {/* END MOBILE-ONLY OUTLINE WRAPPER */}

      {/* Divider between profile card and merged rankings */}
      <div style={{ height: 24 }} />
      <div style={{ height: 1, background: 'var(--border, #e5e5e5)' }} />
      <div style={{ height: 24 }} />

      {/* Entire My Rankings UI, embedded (no extra page chrome) */}
      <MyRankings embedded />
    </div>
  );
};

export default MyProfile;
